<template>
  <div>
    <v-app-bar
      app
      elevate-on-scroll
      color="#FFFFFF"
      elevation="6"
      class="hidden-xs-only"
    >
      <v-layout wrap justify-center fill-height>
        <v-flex xs12 sm11 align-self-center>
          <v-layout wrap justify-center pb-5>
            <v-flex xs4 sm2 md2 lg2 align-self-center>
              <v-layout wrap justify-end>
                <v-flex
                  xs12
                  sm11
                  md11
                  lg12
                  align-self-center
                  py-lg-2
                  py-md-2
                  py-sm-0
                  py-0
                >
                  <router-link to="/">
                    <v-img
                      src="../../src/assets/images/teamitelogo.webp"
                      height="50px"
                      contain
                    />
                  </router-link>
                </v-flex>
              </v-layout>
            </v-flex>

            <v-spacer></v-spacer>

            <!-- Right end with Login and Register buttons -->
            <v-flex xs4 sm6 md4 lg4 align-self-center>
              <v-layout wrap justify-end>
                <v-btn
                  text
                  style="
                    font-family: MontserratMedium;
                    text-transform: capitalize;
                  "
                  color="black"
                  class="mr-2"
                  @click="check()"
                  >Login</v-btn
                >
                <v-btn color="#00A08E" @click="$router.push('/signup')">
                  <span
                    style="
                      color: white;
                      font-family: MontserratMedium;
                      text-transform: capitalize;
                    "
                    >Register Now</span
                  >
                </v-btn>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-app-bar>
    <!-- mobil screen -->
    <v-app-bar app color="#FFFFFF" elevation="6" class="hidden-sm-and-up">
      <v-layout wrap justify-center hidden-sm-and-up>
        <v-flex xs10 sm6 md4 lg4 align-self-center>
          <v-layout wrap justify-center>
            <router-link to="/">
              <v-img
                src="../../src/assets/images/teamitelogo.webp"
                height="50px"
                contain
              />
            </router-link>
          </v-layout>
        </v-flex>
        <v-spacer></v-spacer>
        <v-flex xs2 sm2 md2 lg2 align-self-center>
          <v-layout wrap justify-end>
            <v-flex
              xs12
              sm11
              md11
              lg12
              align-self-center
              py-lg-2
              py-md-2
              py-sm-0
              py-0
            >
              <v-btn icon @click="drawer = !drawer">
                <v-icon>mdi-menu</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-app-bar>

    <!-- Sidebar for Mobile -->
    <v-navigation-drawer v-model="drawer" color="white" app temporary>
      <v-list>
        <v-list-item>
          <v-list-item-title
            style="color: #00a08e; font-family: MontserratBold; font-size: 20px"
            ><v-img
                src="../../src/assets/images/teamitelogo.webp"
                height="50px"
                contain
              /></v-list-item-title
          >
        </v-list-item>
        <v-divider></v-divider>

        <!-- Login and Register buttons inside the drawer -->
        <v-list-item>
          <v-btn
            block
            text
            color="#00A08E"
            style="font-family: MontserratMedium; text-transform: capitalize"
           @click="$router.push('/login')"
            >Login</v-btn
          >
        </v-list-item>
        <v-list-item>
          <v-btn block outlined color="#00A08E" @click="$router.push('/signup')"
            ><span
              style="
                color: #00a08e;
                font-family: MontserratMedium;
                text-transform: capitalize;
              "
              @click="this.$route.push('/login')"
              >Register Now</span
            ></v-btn
          >
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
  </div>
</template>
  <script>
export default {
  data() {
    return {
      drawer: false,
    };
  },

  methods: {
    check() {
  // Retrieve the token (from localStorage as an example)
  const token = localStorage.getItem('token');

  // Check if the token is present
  if (token) {
    // If token is not present, navigate to the login page
    this.$router.push('/login');
  }
  else{
    this.$router.push('/login');
  }
},

  },
};
</script>
<style>
.mobile-drawer {
  z-index: 1000; /* Ensures the drawer is above other content */
}
</style>
